import "../style.scss";
import header from "../../../assets/images/logo_one.svg";
import gmailIcon from "../../../assets/images/Gmail.svg";
import footerImage from "../../../assets/images/footer_img.svg";
import backgroundImage from "../../../assets/images/Login .png";
import { useEffect, useState } from 'react';
import { useAppDispatch } from "../../../hooks/app";
import { getUser, loginUser } from "../../../store/slices/auth-slice";
import { Link, useNavigate } from "react-router-dom";
import useCustomToast from "../../../hooks/useCustomToast";
import UserService from "../../../services/user.service";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { MAIN_TABS } from "../../../constants";
import { getAllTabs, setActiveTab } from "../../../store/slices/layout-slice";

function Login() {
  const dispatch = useAppDispatch()
  const currentUser = useSelector(getUser)
  const customToast = useCustomToast()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const allTabs = useSelector(getAllTabs);
  const setTab = (tab: string) => {
    dispatch(setActiveTab(allTabs.find((t: any) => t.value === tab)));
  };

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false,
  });

  useEffect(() => {
    const msg = localStorage.getItem("msg")
    if (msg) {
      customToast(msg, "success", 3000)
      localStorage.removeItem("msg")
    }
  }, [])

  const [Token, setToken] = useState<string | null>(null);
  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };



  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const { username, password } = formData;
    const response: any = await UserService.login({ username: username, password: password })
    if (response?.status === 200) {
      customToast("Login successfully!", "success");
      dispatch(loginUser(response))
      const { token } = response;
      const { user } = response;
      console.log("user", user?.isSuperuser)
      setToken(token);
          navigate("/")
    }
  };

  return (
    <div className="auth__page">
      <Toaster />
      <div className="row h-100">
        <div className="col-lg-4 col-md-12 p-0">
          <div className="left">
            <img src={header} className="login_logo" alt="Pilot Book" />
            <form>
              <h2 className="welcome heading2">Welcome Back!</h2>
              <h4 className="login_subheading heading4">
                Sign in to continue to Pilots Logbook
              </h4>
              <label className="heading4">username</label>
              <input
                className="input"
                type="text"
                placeholder="Enter Your Username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <label className="heading4">Password</label>
              <input
                className="input"
                type="password" // Change input type to "password" for passwords
                placeholder="Enter Your Password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <div className="checkbox_input">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                <label htmlFor="rememberMe" className="text_checkbox heading4">Remember me</label>
              </div>
              <button className="login_btn" onClick={handleSubmit} disabled={loading}>{loading ? "Signing in" : "Login"}</button>
              <Link to="/forget-password" className="mb-2 d-block">forget password ? </Link>
            </form>
            {/* <h4 className="heading4">Login in with</h4>
            <div className="social_icons">
              <img src={gmailIcon} alt="Gmail Icon" />
            </div> */}
            <h4 className="signup_now heading4">
              Don't have an account ?{" "}
              <Link to="/register">
                <span style={{ textDecoration: "underline", color: "#232629" }}>
                  Signup now
                </span>
              </Link>
            </h4>
            <h4 className="forget_pass heading4">Forgot Password</h4>
            <img src={footerImage} className="footer_img" alt="LandScape" />
            <h4 className="copyright heading4">© 2023 Pilots Logbook</h4>
          </div>
        </div>
        <div className="col-lg-8 d-none d-md-block h-auto p-0">
          <div className="background">
            <img src={backgroundImage} className="login_bg" alt="Login Background" />
            <div className="content">
              <h4 className="login_bg_heading">
                The most complete digital pilot logbook
              </h4>
              <h4 className="login_bg_subheading">
                Pilots Logbook makes your life easier through its super fast flight
                logging, detailed analysis of your flight time with the Analyze view,
                the powerful InSight technology that monitors all your upcoming flights
                and warns you of any rest / duty / currency issues, with all your
                irreplaceable flying life backed up to your choice of iCloud, Dropbox,
                or both!
              </h4>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

export default Login;